import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  userAvatar: {
    id: 'jutro-components.widgets.Avatar.useravatar',
    defaultMessage: 'User avatar'
  }
});